export default __webpack_public_path__ + "static/media/logo_blue.b5c8c5c3.png";